export default "__VITE_ASSET__V_5O17ZZ__"